export const stringCamelCase = (string, bigger) => {
    let string2 = string;
    if (bigger) {
        string2 = string.replace(/^./, (origin) => origin.toUpperCase());
    }
    const HUMP_RE = /[\s_-](.)/g;
    return string2.replace(HUMP_RE, (orign, char) => char.toUpperCase());
};
export const stringKebabCase = (string, separator = '-') => {
    const string2 = string.replace(/^./, (origin) => origin.toLowerCase());
    return string2.replace(/[A-Z]/g, (origin) => `${separator}${origin.toLowerCase()}`);
};
export const STRING_ARABIC_NUMERALS = '0123456789';
export const STRING_LOWERCASE_ALPHA = 'abcdefghijklmnopqrstuvwxyz';
export const STRING_UPPERCASE_ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const placeholderRE = /%[%sdo]/g;
/**
 * 字符串格式化
 * @param {string} string 字符串模板，使用 %s 表示字符串，%d 表示数值，%o 表示对象，%% 表示百分号，参考 console.log
 * @param args
 * @returns {string}
 */
export const stringFormat = (string, ...args) => {
    let index = 0;
    const result = string.replace(placeholderRE, (origin) => {
        const arg = args[index++];
        switch (origin) {
            case '%%':
                index--;
                return '%';
            default:
            case '%s':
                return String(arg);
            case '%d':
                return String(Number(arg));
            case '%o':
                return JSON.stringify(arg);
        }
    });
    return [result, ...args.splice(index).map(String)].join(' ');
};
const ev = (expression, data) => {
    try {
        return new Function('with(arguments[0]){' +
            /****/ `if(arguments[0].${expression} === undefined)throw "";` +
            /****/
            /****/ `return String(arguments[0].${expression})` +
            '}')(data);
    }
    catch (err) {
        throw new SyntaxError(`无法执行表达式：${expression}`);
    }
};
const templateRE = /\${(.*?)}/g;
export const stringAssign = (template, data) => {
    return template.replace(templateRE, (origin, expression) => ev(expression, data));
};
